import { useMemo, type FC } from 'react'
import { getUseConfigStore } from '~/features/webchat/stores/useConfigStore'
import { AppearanceSection } from './sections/Appearance'
import { CustomStylesSection } from './sections/CustomStyles'
import { AsyncButton } from '@bpinternal/ui-kit-next'

type Props = {
  workspaceId: string
  botId: string
}

export const ThemeConfig: FC<Props> = ({ workspaceId, botId }) => {
  const useConfigStore = useMemo(() => getUseConfigStore({ botId, workspaceId }), [botId, workspaceId])

  const saveConfig = useConfigStore((state) => state.saveConfig)
  const _updating = useConfigStore((state) => state._updating)

  return (
    <div className="flex flex-col gap-6">
      <AppearanceSection workspaceId={workspaceId} botId={botId} />
      <CustomStylesSection workspaceId={workspaceId} botId={botId} />
      <AsyncButton loading={_updating} className="self-end" onClick={saveConfig}>
        Save Configuration
      </AsyncButton>
    </div>
  )
}
